package com.example.mystybag.url.logic

import com.example.mystybag.core.logic.base.NavigatorConfig

data class NavigatorURLView(
    val url: String = "",
    val title: String = "",
    val postBody: String = "",
    val successUrlPrefix: String = "",
    val cancelUrlPrefix: String = "",
    val transactionReference: String = "",
    val reservationId: Long = 0L
) : NavigatorConfig()